import { render, staticRenderFns } from "./BundleWorkshop.vue?vue&type=template&id=2de1e7bd&"
import script from "./BundleWorkshop.vue?vue&type=script&lang=js&"
export * from "./BundleWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./BundleWorkshop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports